// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sJ_ug","top":"styles_top__1lPod","left":"styles_left__8FPrY","description":"styles_description__3QQco"};